import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import NewsvalidationSchema from "./Validations/NewsValidations";
import api from "../axiosInstance";
import { toast } from "react-toastify";
import {
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
  BUTTON_STYLES,
  FORM_STYLES,
} from "../styles/componentStyles";
function NewsModal({ open, onClose, newsEdit, onSuccess }) {
  const [universityList, setUniversityList] = useState([]);
  console.log(newsEdit);

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      title: newsEdit?.title || "",
      description: newsEdit?.description || "",
      category: newsEdit?.category || "",
      contentUrl: newsEdit?.contentUrl || "",
      contentType: newsEdit?.contentType || "",
      linkUrl: newsEdit?.linkUrl || "",
      additionalText: newsEdit?.additionalText || "",
      universityId: newsEdit?.universityId || "",
      universityName: newsEdit?.universityName || "",
      displayOrder: newsEdit?.displayOrder || "",
      active: newsEdit?.active ?? "true", // if you want "true" by default
    },

    validationSchema: NewsvalidationSchema,
    enableReinitialize: true,

    onSubmit: async (values, { resetForm }) => {
      console.log(values);
      try {
        let response;
        // If it's Edit data it will call Update api
        if (newsEdit?.id) {
          response = await api.put(
            `/api/v1/update-news/${newsEdit?.id}`,
            values
          );
        }
        // Else it's Add data it will call Add api
        else {
          response = await api.post("/api/v1/update-news", values);
        }
        // Show success toast
        toast.success(
          `News ${newsEdit?.id ? "updated" : "added"} successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          }
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      }
    },
  });
  //   All UniversityList Api Fetching
  useEffect(() => {
    api
      .get("/getAllUniversities")
      .then((res) => setUniversityList(res.data.data))
      .catch((err) => console.error(err));
  }, []);
  return (
    <>
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {newsEdit && Object.keys(newsEdit).length > 0
              ? "Update News"
              : "Add News"}
          </Typography>

          <Box sx={FORM_STYLES.container}>
            <TextField
              label="Title"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.title && Boolean(formik.errors.title)}
              helperText={formik.touched.title && formik.errors.title}
              {...TEXT_FIELD_STYLES.standard}
              required
            />

            <TextField
              multiline
              minRows={2}
              label="Description"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
              {...TEXT_FIELD_STYLES.standard}
            />

            <Box sx={FORM_STYLES.row}>
              <FormControl
                {...TEXT_FIELD_STYLES.standard}
                sx={FORM_STYLES.field.sx}
              >
                <InputLabel>Category</InputLabel>
                <Select
                  label="Category"
                  name="category"
                  value={formik.values.category}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.category && Boolean(formik.errors.category)
                  }
                >
                  <MenuItem value="TIME_TABLE">TIME TABLE</MenuItem>
                  <MenuItem value="RESULTS">RESULTS</MenuItem>
                  <MenuItem value="GENERAL_INFO">GENERAL INFO</MenuItem>
                </Select>
              </FormControl>
              <FormControl
                {...TEXT_FIELD_STYLES.standard}
                sx={FORM_STYLES.field.sx}
              >
                <InputLabel>Content Type</InputLabel>
                <Select
                  label="Content Type"
                  name="contentType"
                  value={formik.values.contentType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.contentType &&
                    Boolean(formik.errors.contentType)
                  }
                >
                  <MenuItem value="PDF">PDF</MenuItem>
                  <MenuItem value="IMAGE">IMAGE</MenuItem>
                  <MenuItem value="LINK">LINK</MenuItem>
                  <MenuItem value="TEXT">TEXT</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box sx={FORM_STYLES.row}>
              <TextField
                label="Content URL"
                name="contentUrl"
                value={formik.values.contentUrl}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.contentUrl && Boolean(formik.errors.contentUrl)
                }
                helperText={
                  formik.touched.contentUrl && formik.errors.contentUrl
                }
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />

              <TextField
                label="Link URL"
                name="linkUrl"
                value={formik.values.linkUrl}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.linkUrl && Boolean(formik.errors.linkUrl)}
                helperText={formik.touched.linkUrl && formik.errors.linkUrl}
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />
            </Box>

            <TextField
              multiline
              minRows={2}
              label="Additional Text"
              name="additionalText"
              value={formik.values.additionalText}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.additionalText &&
                Boolean(formik.errors.additionalText)
              }
              helperText={
                formik.touched.additionalText && formik.errors.additionalText
              }
              {...TEXT_FIELD_STYLES.standard}
            />

            <Box sx={FORM_STYLES.row}>
              <FormControl
                {...TEXT_FIELD_STYLES.standard}
                sx={FORM_STYLES.field.sx}
              >
                <InputLabel>University</InputLabel>
                <Select
                  label="University"
                  name="universityId"
                  value={formik.values.universityId}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    // Set universityId
                    formik.setFieldValue("universityId", selectedId);
                    // Find the selected university object from list
                    const selectedUniversity = universityList.find(
                      (u) => u.id === selectedId
                    );
                    // Set universityName automatically
                    if (selectedUniversity) {
                      formik.setFieldValue(
                        "universityName",
                        selectedUniversity.name
                      );
                    } else {
                      formik.setFieldValue("universityName", "");
                    }
                  }}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.universityId &&
                    Boolean(formik.errors.universityId)
                  }
                >
                  {universityList.map((university) => (
                    <MenuItem value={university.id} key={university.id}>
                      {university.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="University Name"
                disabled
                name="universityName"
                value={formik.values.universityName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.universityName &&
                  Boolean(formik.errors.universityName)
                }
                helperText={
                  formik.touched.universityName && formik.errors.universityName
                }
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />
            </Box>

            <Box sx={FORM_STYLES.row}>
              <TextField
                label="Display Order"
                type="number"
                inputProps={{ min: 0 }}
                name="displayOrder"
                value={formik.values.displayOrder}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.displayOrder &&
                  Boolean(formik.errors.displayOrder)
                }
                helperText={
                  formik.touched.displayOrder && formik.errors.displayOrder
                }
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />

              <FormControl
                {...TEXT_FIELD_STYLES.standard}
                sx={FORM_STYLES.field.sx}
              >
                <InputLabel>Active</InputLabel>
                <Select
                  label="Active"
                  name="active"
                  value={formik.values.active}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.active && Boolean(formik.errors.active)}
                >
                  <MenuItem value="true">Active</MenuItem>
                  <MenuItem value="false">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Box
            sx={FORM_STYLES.actions}
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
              Cancel
            </Button>
            <Button type="submit" {...BUTTON_STYLES.primary}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default NewsModal;
